import { createMuiTheme, MuiThemeProvider, Typography, withStyles, Tooltip, TableCell, Snackbar, TextField } from "@material-ui/core";
import React, { useEffect, useReducer, useState } from 'react';
import MUIDataTable from "mui-datatables";
import MuiAlert from '@material-ui/lab/Alert';
import { useHistory } from 'react-router';
import 'suneditor/dist/css/suneditor.min.css'; // Import Sun Editor's CSS File
import api from '../api';
import { useLocation } from 'react-router-dom';

const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());

const options = ct.customOptionsNofilSearch()
const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}))(Tooltip);

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const style = {
    position: "sticky",
    zIndex: 110
};

export default function DetailResep(props) {
    const [dataTable, setDataTable] = useState([])
    const location = useLocation()
    const [id, setID] = useState("")
    const [patient, setPatient] = useState("")
    const [doctor, setDoctor] = useState("")
    const [transCode, setTransCode] = useState("")
    const [payOption, setPayOption] = useState("")
    const [queueNum, setQueueNum] = useState("")
    const [pharmacyLoc, setPharmacyLoc] = useState("")
    const [pharmacyCode, setPharmacyCode] = useState("")
    const [medicine, setMedicine] = useState("")
    const [quantity, setQuantity] = useState("")
    const [medType, setMedType] = useState("")

    const [messageAlert, setMessageAlert] = useState("")
    const [statusAlert, setStatusAlert] = useState("")
    const [openAlert, setOpenAlert] = useState(false);

    useEffect(() => {
        getDetail()
    }, []);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false)
    }

    const forceUpdate = useReducer(bool => !bool)[1];

    const ResizeImage = (files, uploadHandler) => {
        const uploadFile = files[0];
        const img = document.createElement('img');
        const canvas = document.createElement('canvas');
        const reader = new FileReader();

        reader.onload = function (e) {
            img.src = e.target.result
            img.onload = function () {
                let ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);

                const MAX_WIDTH = 200;
                const MAX_HEIGHT = 100;
                let width = img.width;
                let height = img.height;

                if (width > height) {
                    if (width > MAX_WIDTH) {
                        height *= MAX_WIDTH / width;
                        width = MAX_WIDTH;
                    }
                } else {
                    if (height > MAX_HEIGHT) {
                        width *= MAX_HEIGHT / height;
                        height = MAX_HEIGHT;
                    }
                }

                canvas.width = width;
                canvas.height = height;

                ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0, width, height);

                canvas.toBlob(function (blob) {
                    uploadHandler([new File([blob], uploadFile.name)])
                }, uploadFile.type, 1);
            }
        }

        reader.readAsDataURL(uploadFile);
    }

    const getDetail = (cat) => {
        api.create().getDetailResep(location.state.id[7]).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data[0]
                    setID(data.id)
                    setPatient(data.patient)
                    setDoctor(data.doctor)
                    setTransCode(data.transaction_code_client)
                    setPayOption(data.payment_option)
                    setQueueNum(data.queue_no)
                    setPharmacyLoc(data.pharmacy_location)
                    setPharmacyCode(data.code)
                    if (data.detail.length > 0) {
                        let dataTable = data.detail.map((item, index) => {
                            return [
                                index + 1,
                                item.name,
                                item.qty,
                                item.is_mix
                            ]
                        })
                        setDataTable(dataTable)
                    }
                    forceUpdate()
                }
            }
        })
    }


    const columns = [
        {
            name: "No",
            options: {
                filter: false,
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 110, backgroundColor: 'white' }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.name}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ textAlign: 'left' }}>
                            {val}
                        </div>
                    )
                }
            }
        },
        {
            name: "",
            label: "Item"
        },
        {
            name: "",
            label: "QTY"
        },
        {
            name: "",
            label: "Racikan/Non Racikan",
            options: {
                filter: false,
                customHeadRender: (columnMeta) => (
                    <TableCell style={{ ...style, top: 0, zIndex: 110, backgroundColor: 'white', width: '25%' }}>
                        <Typography style={{ textAlign: 'left', color: '#2a9c6c', fontSize: '12pt' }}>{columnMeta.label}</Typography>
                    </TableCell>
                ),
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ textAlign: 'left' }}>
                            {val}
                        </div>
                    )
                }
            }
        }
    ];

    return (
        <div style={{ maxHeight: props.height - 80, width: '100%', overflow: 'scroll', padding: '20px 0px' }}>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ width: '100%' }}>
                    <Typography style={{ color: 'black', fontWeight: '500', fontSize: 20, fontFamily: 'Poppins' }}>Data Resep</Typography>
                    <div style={{ display: 'flex', marginTop: 20, width: '56%', justifyContent: 'space-between' }}>
                        <Typography style={{ color: 'black', fontWeight: '300', fontSize: 16, fontFamily: 'Poppins', width: '25%' }}>Nama Pasien</Typography>
                        <Typography style={{ color: 'black', fontWeight: '300', fontSize: 16, fontFamily: 'Poppins' }}>:</Typography>
                        <TextField
                            disabled
                            style={{ width: '60%' }}
                            onChange={(e) => {
                                setPatient(e.target.value)
                            }}
                            inputProps={{
                                style: {
                                    fontSize: 14,
                                    color: 'black'
                                }
                            }}
                            InputLabelProps={{
                                style: {
                                    fontSize: 14,
                                    color: '#7e8085',
                                }
                            }}
                            value={patient}
                        />
                    </div>

                    <div style={{ display: 'flex', marginTop: 20, width: '56%', justifyContent: 'space-between' }}>
                        <Typography style={{ color: 'black', fontWeight: '300', fontSize: 16, fontFamily: 'Poppins', width: '25%' }}>Nama Dokter</Typography>
                        <Typography style={{ color: 'black', fontWeight: '300', fontSize: 16, fontFamily: 'Poppins' }}>:</Typography>
                        <TextField
                            disabled
                            style={{ width: '60%' }}
                            onChange={(e) => {
                                setDoctor(e.target.value)
                            }}
                            inputProps={{
                                style: {
                                    fontSize: 14,
                                    color: 'black'
                                }
                            }}
                            InputLabelProps={{
                                style: {
                                    fontSize: 14,
                                    color: '#7e8085',
                                }
                            }}
                            value={doctor}
                        />
                    </div>
                    <div style={{ display: 'flex', marginTop: 20, width: '56%', justifyContent: 'space-between' }}>
                        <Typography style={{ color: 'black', fontWeight: '300', fontSize: 16, fontFamily: 'Poppins', width: '25%' }}>Kode Transaksi</Typography>
                        <Typography style={{ color: 'black', fontWeight: '300', fontSize: 16, fontFamily: 'Poppins' }}>:</Typography>
                        <TextField
                            disabled
                            style={{ width: '60%' }}
                            onChange={(e) => {
                                setTransCode(e.target.value)
                            }}
                            inputProps={{
                                style: {
                                    fontSize: 14,
                                    color: 'black'
                                }
                            }}
                            InputLabelProps={{
                                style: {
                                    fontSize: 14,
                                    color: '#7e8085',
                                }
                            }}
                            value={transCode}
                        />
                    </div>

                    <div style={{ display: 'flex', marginTop: 20, width: '56%', justifyContent: 'space-between' }}>
                        <Typography style={{ color: 'black', fontWeight: '300', fontSize: 16, fontFamily: 'Poppins', width: '25%' }}>Opsi Pembayaran</Typography>
                        <Typography style={{ color: 'black', fontWeight: '300', fontSize: 16, fontFamily: 'Poppins' }}>:</Typography>
                        <TextField
                            disabled
                            style={{ width: '60%' }}
                            onChange={(e) => {
                                setPayOption(e.target.value)
                            }}
                            inputProps={{
                                style: {
                                    fontSize: 14,
                                    color: 'black'
                                }
                            }}
                            InputLabelProps={{
                                style: {
                                    fontSize: 14,
                                    color: '#7e8085',
                                }
                            }}
                            value={payOption}
                        />
                    </div>

                    <div style={{ display: 'flex', marginTop: 20, width: '56%', justifyContent: 'space-between' }}>
                        <Typography style={{ color: 'black', fontWeight: '300', fontSize: 16, fontFamily: 'Poppins', width: '25%' }}>Nomor Antrian Dokter</Typography>
                        <Typography style={{ color: 'black', fontWeight: '300', fontSize: 16, fontFamily: 'Poppins' }}>:</Typography>
                        <TextField
                            disabled
                            style={{ width: '60%' }}
                            onChange={(e) => {
                                setQueueNum(e.target.value)
                            }}
                            inputProps={{
                                style: {
                                    fontSize: 14,
                                    color: 'black'
                                }
                            }}
                            InputLabelProps={{
                                style: {
                                    fontSize: 14,
                                    color: '#7e8085',
                                }
                            }}
                            value={queueNum}
                        />
                    </div>

                    <div style={{ display: 'flex', marginTop: 20, width: '56%', justifyContent: 'space-between' }}>
                        <Typography style={{ color: 'black', fontWeight: '300', fontSize: 16, fontFamily: 'Poppins', width: '25%' }}>Lokasi Farmasi</Typography>
                        <Typography style={{ color: 'black', fontWeight: '300', fontSize: 16, fontFamily: 'Poppins' }}>:</Typography>
                        <TextField
                            disabled
                            style={{ width: '60%' }}
                            onChange={(e) => {
                                setPharmacyLoc(e.target.value)
                            }}
                            inputProps={{
                                style: {
                                    fontSize: 14,
                                    color: 'black'
                                }
                            }}
                            InputLabelProps={{
                                style: {
                                    fontSize: 14,
                                    color: '#7e8085',
                                }
                            }}
                            value={pharmacyLoc}
                        />
                    </div>

                    <div style={{ display: 'flex', marginTop: 20, width: '56%', justifyContent: 'space-between' }}>
                        <Typography style={{ color: 'black', fontWeight: '300', fontSize: 16, fontFamily: 'Poppins', width: '25%' }}>Kode Farmasi</Typography>
                        <Typography style={{ color: 'black', fontWeight: '300', fontSize: 16, fontFamily: 'Poppins' }}>:</Typography>
                        <TextField
                            disabled
                            style={{ width: '60%' }}
                            onChange={(e) => {
                                setPharmacyCode(e.target.value)
                            }}
                            inputProps={{
                                style: {
                                    fontSize: 14,
                                    color: 'black'
                                }
                            }}
                            InputLabelProps={{
                                style: {
                                    fontSize: 14,
                                    color: '#7e8085',
                                }
                            }}
                            value={pharmacyCode}
                        />
                    </div>

                    <div style={{ marginTop: 20, paddingTop: 10, position: 'relative' }}>
                        <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose}>
                            <Alert onClose={handleClose} severity={statusAlert}>
                                {messageAlert}
                            </Alert>
                        </Snackbar>
                        <div >
                            <MuiThemeProvider theme={getMuiTheme()}>
                                <MUIDataTable
                                    data={dataTable}
                                    columns={columns}
                                    options={options}
                                />
                            </MuiThemeProvider>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}